"use client";

import dynamic from "next/dynamic";

const Map = dynamic(() => import("./ListingLocationMap"), { ssr: false });

export default function ListingLocationMapClient(props: { lat: number; lng: number }) {
  return <Map {...props} />;
}
